/**
 * Array of country codes for whose the province is mandatory if selected
 * @type {string[]}
 */
export const PROVINCE_MANDATORY_COUNTRIES = ['US', 'CA'];

export const FREQUENTLY_USED_COUNTRIES = ['US', 'CA'];
